class IsPersonalization extends HTMLElement {
  connectedCallback() {
    this.nameInput = this.querySelector('[data-is-name]');
    this.titleInput = this.querySelector('[data-is-title]');
    this.fontInput = this.querySelector('[data-is-font]');
    this.nameOutput = this.querySelector('[data-is-name-output]');
    this.titleOutput = this.querySelector('[data-is-title-output]');
    this.preview = this.querySelector('[data-is-nameplate]');

    this.nameInput?.addEventListener('input', () => this.update());
    this.titleInput?.addEventListener('input', () => this.update());
    this.fontInput?.addEventListener('change', () => this.update());
    this.update();
  }

  update() {
    if (this.nameOutput) this.nameOutput.textContent = this.nameInput?.value || 'Ahmet Yılmaz';
    if (this.titleOutput) this.titleOutput.textContent = this.titleInput?.value || 'Genel Müdür';
    if (this.preview) this.preview.dataset.font = this.fontInput?.value || 'serif';
  }
}

if (!customElements.get('is-personalization')) {
  customElements.define('is-personalization', IsPersonalization);
}

const isMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
const isMotionItems = new WeakSet();
let isMotionObserver;

const isRevealSelectors = [
  '.is-hero__copy > *',
  '.is-hero__media',
  '.is-trust__item',
  '.is-section-heading > *',
  '.is-collection',
  '.is-featured-products__header > *',
  '.is-featured-products .grid__item',
  '.is-personalization-story__media',
  '.is-personalization-story__copy > *',
  '.is-b2b__grid > *',
  '.is-maker__copy > *',
  '.is-maker__media',
  '.is-guide',
];

function getMotionObserver() {
  if (isMotionObserver) return isMotionObserver;

  isMotionObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  return isMotionObserver;
}

function setupIsMotion(root = document) {
  if (isMotionQuery.matches || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('is-motion-ready');
  const observer = getMotionObserver();

  isRevealSelectors.forEach((selector) => {
    const elements = root.matches?.(selector) ? [root] : [...root.querySelectorAll(selector)];
    elements.forEach((element, index) => {
      if (isMotionItems.has(element)) return;
      isMotionItems.add(element);
      element.dataset.isReveal = element.matches('.is-hero__media, .is-personalization-story__media, .is-maker__media')
        ? 'media'
        : 'content';
      element.style.setProperty('--is-reveal-delay', `${Math.min(index * 55, 220)}ms`);
      observer.observe(element);
    });
  });
}

setupIsMotion();
document.addEventListener('shopify:section:load', (event) => setupIsMotion(event.target));

isMotionQuery.addEventListener?.('change', (event) => {
  if (event.matches) {
    document.documentElement.classList.remove('is-motion-ready');
    document.querySelectorAll('[data-is-reveal]').forEach((element) => element.classList.add('is-revealed'));
  } else {
    setupIsMotion();
  }
});
